import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef, DictionaryItem, SpinnerService } from '@hglobal/common';
import { RootState } from '@pt/store';
import { Store } from '@ngrx/store';
import { GoogleAnalyticModalCloseState, GoogleAnalyticsService } from '@pt/services';

import { TeamBonusesActions, TeamBonusesSelectors, TeamBonusesViewModel } from './store';

export type TeamBonusesType = 'bonus' | 'awards';

@Component({
  standalone: false,
  selector: 'pu-team-bonuses',
  templateUrl: './team-bonuses.component.html',
  styleUrls: ['./team-bonuses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamBonusesComponent implements OnInit {
  readonly #googleAnalyticsService = inject(GoogleAnalyticsService);
  readonly openedFromPersonalInfo = inject<boolean>(DIALOG_DATA);

  vm$: Observable<TeamBonusesViewModel> = this._store.select(TeamBonusesSelectors.selectViewModel);
  type: TeamBonusesType = 'bonus';

  tabs: DictionaryItem<TeamBonusesType>[] = [
    { id: 'bonus', name: this._translate.instant('personalInfo.teamBonuses.tab.bonusCoins') },
    { id: 'awards', name: this._translate.instant('personalInfo.teamBonuses.tab.awards') },
  ];

  constructor(
    private _dialogRef: DialogRef,
    private _translate: TranslateService,
    private _store: Store<RootState>,
    private _spinner: SpinnerService,
  ) {
    this._spinner.observe(this._store.select(TeamBonusesSelectors.selectIsLoading).pipe(
      takeUntilDestroyed(),
    ));
  }

  ngOnInit() {
    this._store.dispatch(TeamBonusesActions.init());
  }

  setType(type: TeamBonusesType) {
    this.type = type;

    if (this.type === 'awards') {
      if (this.openedFromPersonalInfo) {
        this.#googleAnalyticsService.pushCustomEvent('team_bonuses', 'open', {
          element_name: 'reward',
        });
      }
    }
  }

  close(option: GoogleAnalyticModalCloseState): void {
    if (this.openedFromPersonalInfo && this.type === 'awards') {
      this.#googleAnalyticsService.pushCustomEvent('team_bonuses', 'close', {
        element_name: 'reward',
        option,
      });
    }

    this._dialogRef.close();
  }
}
